import gql from 'graphql-tag'

export const LOGOUT_MUTATION = gql`
  mutation ($account: String!) {
    update_session(
      where: { account: { _eq: $account } }
      _set: { is_valid: false }
    ) {
      affected_rows
    }
  }
`
